module.exports = __webpack_public_path__ + "static/media/beach.a42b3400.jpg";